var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c("div", { staticClass: "loading" }, [
          _c(
            "div",
            { staticClass: "md-layout md-gutter md-alignment-top-center" },
            [
              _c("md-progress-spinner", {
                attrs: {
                  "md-diameter": 50,
                  "md-stroke": 5,
                  "md-mode": "indeterminate"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "md-layout md-gutter md-alignment-top-center" },
          [
            _c(
              "div",
              {
                staticClass:
                  "\n        md-layout-item\n        md-size-20\n        md-medium-size-10\n        md-small-size-10\n        md-xsmall-size-0\n      "
              },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-fab",
                    on: {
                      click: function($event) {
                        return _vm.goBack()
                      }
                    }
                  },
                  [_c("md-icon", [_vm._v("arrow_back")])],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "\n        md-layout-item\n        md-size-60\n        md-medium-size-70\n        md-small-size-100\n        md-xsmall-size-100\n      "
              },
              [
                _c(
                  "md-card",
                  [
                    _c("md-card-header", [
                      _c("div", { staticClass: "md-title" }, [
                        _vm._v("Potenzielle Projektpartner")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "md-card-content",
                      [
                        _vm.partners.length > 0
                          ? _c("p", [
                              _vm._v(
                                "\n            Die unten stehenden Unternehmen werden Ihnen angezeigt, weil Sie\n            laut Ihrem Unternehmensprofil eine oder mehrere Technologien\n            suchen, die diese Unternehmen laut der Angaben in deren jeweiligem\n            Unternehmensprofil anbieten/anwenden. Die Liste ist alphabetisch\n            sortiert.\n          "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.partners.length == 0
                          ? _c("div", [
                              _vm._v(
                                "\n            Keine passenden Partner gefunden.\n          "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.profile && _vm.profile.requested.length == 0
                          ? _c(
                              "div",
                              [
                                _vm._v(
                                  "\n            Um Ihnen Partner anzeigen zu können, benötigen wir Technologien\n            nach denen Sie suchen bzw. für die Sie sich interessieren. Sie\n            können diese in Ihrem\n            "
                                ),
                                _c(
                                  "router-link",
                                  { attrs: { to: { name: "ProfileCreate" } } },
                                  [_vm._v("Unternehmensprofil ")]
                                ),
                                _vm._v("eintragen.\n          ")
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "Partners" } } },
                              [_vm._v("Hier")]
                            ),
                            _vm._v(
                              "\n            kommen Sie zurück zu allen Unternehmen.\n          "
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.partners, function(item) {
                          return _c(
                            "div",
                            { key: item.name },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "no-link",
                                  attrs: {
                                    to: {
                                      name: "CompanyDetail",
                                      params: { hash: item.hash }
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "md-card",
                                    {
                                      staticClass:
                                        "margin-twenty md-alignment-top-center md-elevation-1",
                                      attrs: { "md-with-hover": "" }
                                    },
                                    [
                                      _c(
                                        "md-card-header",
                                        { staticClass: "md-title" },
                                        [_vm._v(_vm._s(item.name))]
                                      ),
                                      _vm._v(" "),
                                      _c("md-card-content", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.shorten(item.description)
                                          )
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "\n        md-layout-item\n        md-size-20\n        md-medium-size-15\n        md-small-size-10\n        md-xsmall-size-0\n      "
            })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60d0bf23", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60d0bf23","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/profile/partners/MyPartners.vue
// module id = null
// module chunks = 